import { get } from '@/lib/request/index'
import { deepLink } from '../apiConstants'

// 获取深链接
export function getDeepLink(param) {
  return get(deepLink.GET_DEEP_LINK, { param })
}
